export default class Ground extends createjs.Container {

    private img: HTMLImageElement;
    private speed: any;
    private canvas: HTMLCanvasElement;
    protected height: number;
    protected width: number;
    public bg: createjs.Bitmap;
    public static _x: number;
    public static _y: number;
    private action: any;

    constructor(img: HTMLImageElement, canvas: HTMLCanvasElement) {
        super();
        this.bg = new createjs.Bitmap(img);
        this.height = img.height;
        this.width = img.width;
        this.init();

        this.img = img;
        this.speed = 1;
        this.canvas = canvas;
        Ground._x = Ground._y = 0;
    }

    public init(): void {
        this.addChild(this.bg);
        this.setDefualtAction();
        document.addEventListener('keyup', (event: any) => { this.keyUpEvents(event) }, false);
        document.addEventListener('keydown', (event: any) => { this.keyDownEvents(event) }, false);
    }

    public static getX(): number {
        return Ground._x;
    }

    private setDefualtAction() {
        this.action = {
            'up': false,
            'down': false,
            'left': false,
            'right': false
        };
    }

    public move(): void {
        if (this.action.up === true) {
            this.y += 10;
        }
        if (this.action.down === true) {
            this.y -= 10;
        }
        if (this.action.left === true) {
            this.x += 10;
        }
        if (this.action.right === true) {
            this.x -= 10;
        }
    }

    private keyDownEvents(event: any) {
        // this.setDefualtAction();
        if (event.target.outerHTML.indexOf('</body>') == -1) {
            return;
        }
        switch (event.keyCode) {
            case 38:
                event.preventDefault();
                this.action.up = true;
                break;
            case 40:
                event.preventDefault();
                this.action.down = true;
                break;
            case 37:
                event.preventDefault();
                this.action.left = true;
                break;
            case 39:
                event.preventDefault();
                this.action.right = true;
                break;
        }
    }

    private keyUpEvents(event: any) {
        if (event.target.outerHTML.indexOf('</body>') == -1) {
            return;
        }
        switch (event.keyCode) {
            case 38:
                event.preventDefault();
                this.action.up = false;
                break;
            case 40:
                event.preventDefault();
                this.action.down = false;
                break;
            case 37:
                event.preventDefault();
                this.action.left = false;
                break;
            case 39:
                event.preventDefault();
                this.action.right = false;
                break;
        }
    }

    public removeByName(name: string): void {
        var child = this.getChildByName(name);
        if (child !== null) {
            this.removeChild(child);
        }
    }
    public zIndexUp(name: string): void {
        var child = this.getChildByName(name);
        if (child !== null) {
            this.removeChild(child);
			this.addChild(child);
        }
    }
}



// WEBPACK FOOTER //
// ./components/family_tree/items/Ground.ts